
const Whyus = () => {
  return (
    
    <section className="py-16 bg-gray-50" id="whyus">
  <div className="container mx-auto px-6">
    <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0F172A] mb-4">Why EquiCore Nexus</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#3B82F6] to-emerald-500 mx-auto rounded-full"></div>
          <p className="text-xl text-gray-600 mt-6 max-w-3xl mx-auto">
        What sets us apart in the world of strategic financial advisory
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {/* Card 1 */}
      <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
        <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-3 text-gray-900">Industry Deep Dive</h3>
        <p className="text-gray-600">
          From manufacturing floors to deep-tech corridors — we understand what drives your industry.
        </p>
      </div>

      {/* Card 2 */}
      <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
        <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-3 text-gray-900">Finance + Ops Intelligence</h3>
        <p className="text-gray-600">
          We bridge business strategy with numbers through integrated operational and financial models.
        </p>
      </div>

      {/* Card 3 */}
      <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
        <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-3 text-gray-900">AI-Powered, Human-Led</h3>
        <p className="text-gray-600">
          Our models leverage AI tools for speed, but decisions are always rooted in expert judgment.
        </p>
      </div>

      {/* Card 4 */}
      <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
        <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-3 text-gray-900">Premium Research Stack</h3>
        <p className="text-gray-600">
          We subscribe to top-tier research and databases for unbeatable market intelligence.
        </p>
      </div>

      {/* Card 5 */}
      <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
        <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-3 text-gray-900">Global Experience, Local Nuance</h3>
        <p className="text-gray-600">
          15+ man-years across India and global markets, with real investor expectations in mind.
        </p>
      </div>

      {/* Card 6 */}
      <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
        <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-3 text-gray-900">Investor-Ready Modeling</h3>
        <p className="text-gray-600">
          Be it LBOs, ESOPs, cap tables, or exits — we handle complexity with clarity.
        </p>
      </div>
    </div>

    {/* Bottom CTA */}
    <div className="mt-16 text-center">
      <a href="/#contact" className="inline-flex items-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors shadow-sm">
        Discover Our Approach
        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
        </svg>
      </a>
    </div>
  </div>
</section>
        
  );
};

export default Whyus;